import React from 'react';
import { Button, LoadingButton } from '@helpcenter/analytics-components';
import { useIntl } from 'react-intl';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import ModalBody from '@atlaskit/modal-dialog/modal-body';
import ModalFooter from '@atlaskit/modal-dialog/modal-footer';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import ModalTransition from '@atlaskit/modal-dialog/modal-transition';
import messages from './messages';

export interface Props {
	isOpen: boolean;
	onClose: () => void;
	onUnlink: () => void;
	isLoading: boolean;
	projectName?: string;
	numberOfProjects: number;
}

export const UnlinkConfirmationModal = ({
	isOpen,
	onClose,
	onUnlink,
	isLoading,
	projectName,
	numberOfProjects,
}: Props) => {
	const { formatMessage } = useIntl();

	let modalTitle: string;
	let modalDescription: string;

	if (numberOfProjects > 1) {
		modalTitle = FeatureGates.checkGate('itsm-project-renaming')
			? formatMessage(messages.bulkUnlinkModalTitleGalaxia, { number: numberOfProjects })
			: formatMessage(messages.bulkUnlinkModalTitle, { number: numberOfProjects });
		modalDescription = FeatureGates.checkGate('itsm-project-renaming')
			? formatMessage(messages.bulkUnlinkModalDescGalaxia)
			: formatMessage(messages.bulkUnlinkModalDesc);
	} else {
		modalTitle = FeatureGates.checkGate('itsm-project-renaming')
			? formatMessage(messages.unlinkModalTitleGalaxia)
			: formatMessage(messages.unlinkModalTitle);
		modalDescription = FeatureGates.checkGate('itsm-project-renaming')
			? formatMessage(messages.unlinkModalDescGalaxia, { projectName })
			: formatMessage(messages.unlinkModalDesc, { projectName });
	}

	return (
		<ModalTransition>
			{isOpen && (
				<Modal width="small" onClose={onClose}>
					<ModalHeader>
						<ModalTitle appearance="warning" testId="help-center-unlink-modal-title">
							{modalTitle}
						</ModalTitle>
					</ModalHeader>
					<ModalBody>{modalDescription}</ModalBody>
					<ModalFooter>
						<LoadingButton
							onClick={onUnlink}
							isLoading={isLoading}
							appearance="warning"
							actionSubjectId="unlinkModalConfirmButton"
							testId="unlink-modal-confirm-button"
						>
							{formatMessage(messages.unlinkModalConfirmButton)}
						</LoadingButton>
						<Button onClick={onClose} appearance="subtle" actionSubjectId="unlinkModalCancelButton">
							{formatMessage(messages.unlinkModalCancelButton)}
						</Button>
					</ModalFooter>
				</Modal>
			)}
		</ModalTransition>
	);
};
